import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'Masters/CustomField/CustomFieldTypes', method: 'GET', body: null, token: token })
}
